import { jsxs as I, jsx as u } from "react/jsx-runtime";
import R, { useState as h, useRef as z, useEffect as p } from "react";
import { R as _, I as N } from "../chunks/index.cff5baaf.js";
import { _ as $, a as j, b as L } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import l, { css as s } from "styled-components";
const r = l.span.withConfig({
  displayName: "Checkmark",
  componentId: "sc-1urkvuw-0"
})(["align-items:center;border-color:var(--unselected-border);border-radius:var(--border-radius-xs);border-style:solid;border-width:var(--default-border-width);display:flex;height:var(--spacing-3x);justify-content:center;position:relative;width:var(--spacing-3x);box-sizing:border-box;transition-property:background-color;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);&:before{border-radius:var(--default-border-radius);display:block;content:'';height:var(--spacing-6x);left:calc(50% - var(--spacing-3x));position:absolute;top:calc(50% - var(--spacing-3x));width:var(--spacing-6x);z-index:-1;transition-property:background-color;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);}"]), M = l.label.withConfig({
  displayName: "Checkbox",
  componentId: "sc-1urkvuw-1"
})(["", " color:var(--text-label-color);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;gap:var(--spacing-1x);position:relative;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;height:var(--size-6x);width:var(--size-6x);&:hover{", "{transition-timing-function:var(--curve-productive-entrance);&:before{", "}}}", " ", " ", " ", ""], $, r, j, (e) => e.$isLabel && s(["width:unset;"]), (e) => (e.selected || e.$indeterminate) && s(["", "{color:var(--on-selected-icon-color);}", "{border-color:transparent;background-color:var(--selected-bg-color);transition-timing-function:var(--curve-productive-entrance);}"], b, r), (e) => e.disabled && s(["color:var(--disabled-label-color);opacity:var(--opacity-low);pointer-events:none;", "{color:var(--on-disabled-icon-color);}", "{border-color:var(--disabled-border-color);}"], b, r), (e) => e.disabled && (e.selected || e.$indeterminate) && s(["", "{background-color:var(--disabled-bg-color);border-color:transparent;}"], r)), S = l.input.withConfig({
  displayName: "Input",
  componentId: "sc-1urkvuw-2"
})(["all:unset;position:absolute;&:focus-visible ~ ", "{", " outline-offset:2px;}"], r, L), b = l(_).withConfig({
  displayName: "Icon",
  componentId: "sc-1urkvuw-3"
})([""]), E = R.forwardRef(({
  children: e,
  selected: n = !1,
  indeterminate: o = !1,
  disabled: f = !1,
  ariaLabel: m,
  inputProps: t,
  ...x
}, k) => {
  const [a, i] = h(n), [C, v] = h(o), w = z();
  p(() => {
    i(n);
  }, [n]), p(() => {
    n || (v(o), i(o));
  }, [o, n]);
  const g = (c) => /* @__PURE__ */ u(b, { icon: c, size: N.SM }), y = () => o && a ? g("MinusLine") : a ? g("CheckLine") : null;
  return /* @__PURE__ */ I(M, { "aria-label": m, selected: a, $indeterminate: C, disabled: f, $isLabel: !!e, ref: k, "data-testid": "rango-checkbox", "data-rango-component": "rango-checkbox", "data-is-rango": !0, ...x, children: [
    /* @__PURE__ */ u(S, { ...t, type: "checkbox", "data-testid": "rango-checkbox-input", defaultChecked: a, disabled: f, ref: w, onChange: (c) => {
      const {
        checked: d
      } = c.target;
      o ? (v(!d), i(!d)) : i(d), t != null && t.onChange && t.onChange(c);
    } }),
    /* @__PURE__ */ u(r, { children: y() }),
    e
  ] });
});
E.displayName = "RangoCheckbox";
export {
  E as RangoCheckbox
};
